package ru.it_mozaika.sender.js.application.context


import js.core.jso
import react.*
import ru.it_mozaika.sender.common.models.User
import ru.it_mozaika.utils.UserApi
import web.window.WindowTarget
import web.window.window

val UserContext = createContext<UserContextInterface>(jso {
    currentUser = null
    logout = { currentUser = null }
})
val UserProvider = FC<PropsWithChildren> { props ->
    val backdrop = useBackdrop()
    var user by useState<User>()
    useEffect(user) {
        println("Current user $user")
        if (user == null) {
            UserApi.getUser {
                println("User $it")
                if (it != null) {
                    user = it
                } else {
                    window.open("/login", WindowTarget._self)
                }
            }
        }
    }
    UserContext.Provider {
        value = jso {
            this.currentUser = user
            this.logout = {
                backdrop.show()
                UserApi.logout {
                    user = null
                }
            }
        }
        if (user != null) {
            +props.children
        }
    }
}
external interface UserContextInterface {
    var currentUser: User?
    var logout: () -> Unit
}
operator fun UserContextInterface.component1(): User? {
    return currentUser
}
operator fun UserContextInterface.component2(): () -> Unit {
    return logout
}
fun useUser() = useContext(UserContext)
